import { GroopitFilterDisplayDTO } from "groopit-js/client";
import {
  getComponentFilterDescription,
  getDateDescription,
  ReadableDataTypeNames,
} from "./FilterStrings";
import {
  isDefaultFilter,
  isDefaultFilterForCurrentTime,
  UnnamedGroopitFilterDisplayDTO,
} from "./GroopitFilterDTO";

export function FilterSummaryGenerator(
  filter: GroopitFilterDisplayDTO,
): string {
  const globalFilters: string[] = [];
  if (filter.creators?.length) {
    globalFilters.push(...filter.creators.map((c) => c.friendlyName));
  }
  if (filter.dateRange) {
    globalFilters.push(getDateDescription(filter.dateRange));
  }
  if (filter.tags?.length) {
    globalFilters.push(...filter.tags.map((tag) => `#${tag}`));
  }
  if (filter.choices?.length) {
    globalFilters.push(...filter.choices.map((choice) => `#${choice}`));
  }
  if (filter.feedFilterDataTypes?.length) {
    globalFilters.push(
      ...filter.feedFilterDataTypes.map((dataType) =>
        ReadableDataTypeNames.get(dataType),
      ),
    );
  }
  if (filter.query) {
    globalFilters.push(...filter.query);
  }

  const isDefault = isDefaultFilter(
    new UnnamedGroopitFilterDisplayDTO({ filter }),
  );
  const endDateIsNow = isDefaultFilterForCurrentTime(
    new UnnamedGroopitFilterDisplayDTO({ filter }),
  );

  if (isDefault) {
    return "all data";
  }

  if (endDateIsNow) {
    return "all data " + globalFilters.join(" | ");
  }

  const assignmentTexts = filter.assignments.map((assignment) => {
    const assignmentSubFilters: string[] = [];
    if (assignment.creators?.length) {
      assignmentSubFilters.push(
        ...assignment.creators.map((c) => c.friendlyName),
      );
    }
    if (assignment.dateRange) {
      assignmentSubFilters.push(getDateDescription(assignment.dateRange));
    }
    if (assignment.components?.length) {
      assignmentSubFilters.push(
        ...assignment.components.map((c) => getComponentFilterDescription(c)),
      );
    }

    if (assignmentSubFilters.length) {
      return `${assignment.title} (${assignmentSubFilters.join(" | ")})`;
    } else {
      return assignment.title;
    }
  });

  let summary = assignmentTexts.join(" ");
  if (globalFilters.length && filter.assignments.length) {
    summary += ` | ${globalFilters.join(" | ")}`;
  } else {
    summary += globalFilters.join(" | ");
  }
  return summary.trim();
}
